import firebase from "firebase/compat/app";
import formatUserData from "../utils/formatUserData";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import getGroupInfoById from "../data/getGroupInfoById";

const getUserList = async function (type, value, adminList) {
  let db = firebase.firestore();
  const userList = [];
  if (type == "getAdminUser") {
    const userSnapshot = await db
      .collection("wellness_users")
      .where("role", "in", ["challengeAdmin", "superAdmin"])
      .get();

    userSnapshot.forEach((doc) => {
      userList.push(formatUserData(doc.id, doc.data()));
    });
  } else if (type == "getChallengeAdminUser") {
    const userSnapshot = await db
      .collection("wellness_users")
      .where("role", "in", ["challengeAdmin"])
      .get();

    userSnapshot.forEach((doc) => {
      if (doc.id != value) {
        const item = formatUserData(doc.id, doc.data());
        let displayText = item.phoneNumber ? item.phoneNumber : item.email;
        if (displayText.startsWith('line-')) {
          displayText = 'Line';
        }
        userList.push({
          'value': doc.id,
          'text': item.name + " (" + displayText + ")"
        });
      }
    });
  } else if (type == "getGroupOwner") {
    const userSnapshot = await db
      .collection("wellness_users")
      .get();

    userSnapshot.forEach((doc) => {
      if (doc.id != value) {
        const item = formatUserData(doc.id, doc.data());
        let displayText = item.phoneNumber ? item.phoneNumber : item.email;
        if (displayText && displayText.startsWith('line-')) {
          displayText = 'Line';
        }
        userList.push({
          'value': doc.id,
          'text': item.name + " (" + displayText + ")"
        });
      }
    });
  } else if (type == "filter") {
    const adminListFilter = [];
    adminList.forEach((user) => {
      adminListFilter.push(user.uid);
    });

    //filter from firstname
    const firstNameSnapshot = await db
      .collection("wellness_users")
      .where("firstname", ">=", value)
      .limit(5)
      .get();
    firstNameSnapshot.forEach((doc) => {
      if (!adminListFilter.includes(doc.id)) {
        adminListFilter.push(doc.id); //do not show duplicated list
        userList.push(formatUserData(doc.id, doc.data()));
      }
    });

    //filter from lastname
    const lastNameSnapshot = await db
      .collection("wellness_users")
      .where("lastname", ">=", value)
      .limit(5)
      .get();
    lastNameSnapshot.forEach((doc) => {
      if (!adminListFilter.includes(doc.id)) {
        adminListFilter.push(doc.id); //do not show duplicated list
        userList.push(formatUserData(doc.id, doc.data()));
      }
    });

    //filter from phone
    const phoneSnapshot = await db
      .collection("wellness_users")
      .where("phoneNumber", ">=", value)
      .limit(5)
      .get();
    phoneSnapshot.forEach((doc) => {
      if (!adminListFilter.includes(doc.id)) {
        adminListFilter.push(doc.id); //do not show duplicated list
        userList.push(formatUserData(doc.id, doc.data()));
      }
    });
  } else if (type == "verifyByCompetitionId") {
    const userSnapshot = await db
      .collection("wellness_competition")
      .doc(value)
      .collection("users")
      .get();

    userSnapshot.forEach(async (doc) => {
      const userInfo = await getUserInfoByUserId(doc.id);
      userInfo.verifyInfo = {};
      if (doc.data() != undefined) {
        userInfo.verifyInfo = doc.data();
      }

      if (userInfo.verifyInfo.groupId) {
        const groupInfo = await getGroupInfoById(userInfo.verifyInfo.groupId);
        userInfo.groupInfo = groupInfo;
      }
      userList.push(userInfo);
    });
  }

  return userList;
};

export default getUserList;